import { render } from "./DashboardChartCard.vue?vue&type=template&id=5d9e84f8&scoped=true"
import script from "./DashboardChartCard.vue?vue&type=script&lang=js"
export * from "./DashboardChartCard.vue?vue&type=script&lang=js"

import "./DashboardChartCard.vue?vue&type=style&index=0&id=5d9e84f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9e84f8"]])

export default __exports__